/**
 * @generated SignedSource<<6622c15a74ff43a74e53a59dba19f7a8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignsLayout_viewer$data = {
  readonly iconicDesignsDirectoryPage: {
    readonly " $fragmentSpreads": FragmentRefs<"DesignsCarousel_iconicDesignsDirectoryPage" | "DesignsDirectory_iconicDesignsDirectoryPage" | "DesignsFeaturedItems_iconicDesignsDirectoryPage">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"DesignsDirectory_viewer">;
  readonly " $fragmentType": "DesignsLayout_viewer";
};
export type DesignsLayout_viewer$key = {
  readonly " $data"?: DesignsLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignsLayout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignsLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DesignsDirectory_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IconicDesignsDirectoryPage",
      "kind": "LinkedField",
      "name": "iconicDesignsDirectoryPage",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DesignsCarousel_iconicDesignsDirectoryPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DesignsDirectory_iconicDesignsDirectoryPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DesignsFeaturedItems_iconicDesignsDirectoryPage"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6a87ec3d0f938d4bee86d501911b9bcc";

export default node;
